/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const FETCH_COGNITO_USERS_REQUEST = 'FETCH_COGNITO_USERS_REQUEST';
export const FETCH_COGNITO_USERS_SUCCESS = 'FETCH_COGNITO_USERS_SUCCESS';
export const FETCH_COGNITO_USERS_FAILURE = 'FETCH_COGNITO_USERS_FAILURE';
